/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-param-reassign */
import React from 'react';
import { createColumnHelper, PaginationState, RowSelectionState } from '@tanstack/react-table';
import { BiBookmark } from 'react-icons/bi';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import {
  Avatar, Checkbox, Chip, FormControlLabel, Popover, Rating, Tooltip,
} from '@mui/material';

import {
  MdCallMade, MdOutlineBookmarks, MdShare,
} from 'react-icons/md';
import { BsFillBookmarkFill } from 'react-icons/bs';

import { CloseIcon, EmailIcon } from 'src/icons';
import PhoneIcon from 'src/icons/Phone';
import { Table } from 'src/components';
import { TablePaginationState } from 'src/components/Table';
import { useApplyJob } from 'src/hooks/query/jobs';
import { useShareProfiles } from 'src/hooks/query/shareProfiles';
import { options as currencyOptions } from 'src/components/elements/Input';

// import data from '../../sample-data';
import { useLocations } from 'src/hooks/query/locations';
import { useJobTypes } from 'src/hooks/query/job-types';
import { TalentPoolCandidateRecord } from '../../types';
import ApplyToJobForm, { ApplyJobFormValues } from '../ApplyToJobForm';
import ShareProfileForm, { ShareProfileFormValues } from '../ShareProfileForm';

const columnHelper = createColumnHelper<
TalentPoolCandidateRecord & { sNo?: number, selection?: boolean }
>();

interface TalentPoolTableProps {
  openBookmarks: boolean;
  onToggleBookmarks: () => void;
  onRowSelectionChange: (data: RowSelectionState) => void;
  rowSelection: RowSelectionState;
  pagination: TablePaginationState;
  onChangePagination: (data: PaginationState) => void;
  records: TalentPoolCandidateRecord[];
  profilesFetching: boolean;
  onRowClick: (row: TalentPoolCandidateRecord) => void;
  bookmarkProfile: (row: TalentPoolCandidateRecord) => void;
  onAfterJobApply: () => void;
}

const TalentPoolTable = function TalentPoolTable(props: TalentPoolTableProps) {
  const {
    openBookmarks, onToggleBookmarks, onRowSelectionChange,
    rowSelection, pagination, onChangePagination,
    records, profilesFetching, onRowClick,
    bookmarkProfile, onAfterJobApply,
  } = props;
  const selectedMultipleCandidates = React.useMemo(() => Object.keys(rowSelection).length >= 2, [
    rowSelection,
  ]);
  const { locationsOptions } = useLocations();
  const { jobTypesOptions } = useJobTypes();
  const columns = React.useMemo(() => [
    columnHelper.accessor('name', {
      header: ({ table }) => (
        <div className="flex items-center justify-between">
          <div className="ml-4 flex gap-1 items-center">
            <FormControlLabel
              control={(
                <Checkbox
                  indeterminate={table.getIsSomeRowsSelected()}
                  checked={table.getIsAllRowsSelected()}
                  onChange={table.getToggleAllRowsSelectedHandler()}
                  size="small"
                />
              )}
              label="Select All"
            />
          </div>
          <Tooltip title={!openBookmarks ? 'Your Bookmarks' : 'Close Bookmarks'} placement="left">
            <div
              onClick={onToggleBookmarks}
              className="mr-3 flex p-1 cursor-pointer justify-center text-xs items-center gap-2"
            >
              {openBookmarks ? <IoMdCloseCircleOutline className="h-5 w-5" /> : (
                <MdOutlineBookmarks className="h-5 w-5" />
              )}
            </div>
          </Tooltip>
        </div>
      ),
      cell: ({ row }) => {
        const {
          name, candidateTitle, createdDate, candidateStatus,
          updatedDate, location, reLocation,
          experienceLevel, payRate, noticePeriod,
          score, techSkill, oldTechSkill, communicationSkills, oldCommunicationSkills,
          phoneNumber, emailAddress,
          interviewComments,
          pannaInterviewComments,
          candidateId,
          visaStatus,
          currency,
        } = row.original;
        const { applyJob, isPending } = useApplyJob();
        const { shareProfiles, shareProfilesPending } = useShareProfiles();
        const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

        const currencyOption = currencyOptions.find((option) => option.currencyName === currency);
        const currencyIcon = currencyOption?.currencyIcon || '$';

        const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
          setAnchorEl(event.currentTarget);
        };

        const handlePopoverClose = () => {
          setAnchorEl(null);
        };

        const open = Boolean(anchorEl);

        const [pannaInterviewAnchorEl, setpannaAnchorEl] = React.useState<HTMLElement | null>(null);

        const handlePannaInterviewPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
          setpannaAnchorEl(event.currentTarget);
        };

        const handlePannaInterviewPopoverClose = () => {
          setpannaAnchorEl(null);
        };

        const pannaInterviewOpen = Boolean(pannaInterviewAnchorEl);

        const [applyJobAnchorEl, setApplyJobAnchorEl] = React.useState<HTMLElement | null>(null);
        const [
          shareProfileAnchorEl, setShareProfileAnchorEl,
        ] = React.useState<HTMLElement | null>(null);

        const handleApplyToJobFormSubmit = async (data: ApplyJobFormValues) => {
          try {
            await applyJob({
              candidateIds: [Number(candidateId)],
              jobOrderId: data.jobId,
            });
            onAfterJobApply();
            setApplyJobAnchorEl(null);
          } catch (e) {
            console.log(e);
          }
        };

        const handleShareProfilesSubmit = async (data: ShareProfileFormValues) => {
          try {
            await shareProfiles({
              candidateIds: [Number(candidateId)],
              toList: data.emails.join(','),
              comments: data.comments,
            });
            setShareProfileAnchorEl(null);
          } catch (e) {
            console.log(e);
          }
        };

        return (
          <>
            <div
              className="flex relative z-0"
            >
              <div className="absolute gap-2 right-4 flex top-4 z-50">
                <Popover
                  open={Boolean(applyJobAnchorEl)}
                  anchorEl={applyJobAnchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  onClose={(e) => {
                    if (e) {
                      (e as Event).stopPropagation();
                    }
                    setApplyJobAnchorEl(null);
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className="absolute right-2 top-2"
                    onClick={(e) => {
                      if (e) {
                        e.stopPropagation();
                      }
                      setApplyJobAnchorEl(null);
                    }}
                  >
                    <CloseIcon className="cursor-pointer" />
                  </div>
                  <ApplyToJobForm onSubmit={handleApplyToJobFormSubmit} loading={isPending} />
                </Popover>

                <Popover
                  open={Boolean(shareProfileAnchorEl)}
                  anchorEl={shareProfileAnchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  onClose={(e) => {
                    if (e) {
                      (e as Event).stopPropagation();
                    }
                    setShareProfileAnchorEl(null);
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className="absolute right-2 top-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShareProfileAnchorEl(null);
                    }}
                  >
                    <CloseIcon className="cursor-pointer" />
                  </div>
                  <ShareProfileForm
                    onSubmit={handleShareProfilesSubmit}
                    loading={shareProfilesPending}
                  />
                </Popover>

                <Tooltip title="Apply to">
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (!selectedMultipleCandidates) {
                        setApplyJobAnchorEl(e.currentTarget);
                      }
                    }}
                    className="border border-solid border-[#ddd] rounded-full p-[4px] flex items-center justify-center cursor-pointer h-6 w-6"
                  >
                    <MdCallMade className="w-full h-full" />
                  </div>
                </Tooltip>
                <Tooltip title="Share profile">
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (!selectedMultipleCandidates) {
                        setShareProfileAnchorEl(e.currentTarget);
                      }
                    }}
                    className="border border-solid border-[#ddd] rounded-full p-[4px] flex items-center justify-center cursor-pointer h-6 w-6"
                  >
                    <MdShare className="w-full h-full" />
                  </div>
                </Tooltip>
                <Tooltip title={row?.original?.isBookMarked ? 'Unbookmark' : 'Bookmark'}>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      bookmarkProfile(row.original);
                    }}
                    className="border border-solid border-[#ddd] rounded-full p-[4px] flex items-center justify-center cursor-pointer h-6 w-6"
                  >
                    {row?.original?.isBookMarked && <BsFillBookmarkFill className="w-full fill-primary h-full" />}
                    {!row?.original?.isBookMarked && <BiBookmark className="w-full h-full" />}
                  </div>
                </Tooltip>
              </div>
              <div className="flex items-center justify-center pl-0 p-2">
                <div className="ml-4">
                  <Checkbox
                    indeterminate={row.getIsSomeSelected()}
                    checked={row.getIsSelected()}
                    disabled={!row.getCanSelect()}
                    onMouseDown={(event) => {
                      event.stopPropagation();
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    onChange={row.getToggleSelectedHandler()}
                  />
                </div>
                <div className="col-span-4 flex justify-center items-start">
                  <div className="px-4 items-center justify-center flex flex-col gap-2">
                    <Avatar
                      className=""
                      sx={{ width: 60, height: 60 }}
                    />
                    <div className="flex items-center gap-2 justify-between">
                      <Tooltip
                        placement="left"
                        title={(
                          <div>
                            {phoneNumber || 'unknown'}
                          </div>
                        )}
                      >
                        <div>
                          <PhoneIcon className="h-4 w-4" />
                        </div>
                      </Tooltip>
                      <Tooltip
                        placement="right"
                        title={(
                          <div>
                            {emailAddress || 'unknown'}
                          </div>
                        )}
                      >
                        <div>
                          <EmailIcon className="h-5 w-5" />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gap-1  py-4 flex flex-col">
                <div className="flex gap-2 pb-2">
                  <span className="font-bold text-sm">{`${name}`}</span>
                  {candidateTitle && (
                    <div>
                      <Chip size="small" label={jobTypesOptions.find((jobType) => jobType.value === candidateTitle)?.label} />
                    </div>
                  )}
                </div>
                <div className="grid gap-4 grid-cols-12">
                  <div className="flex flex-col gap-2 col-span-3">
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Added on</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{createdDate}</span>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Last status</span>
                      <Tooltip title={candidateStatus}>
                        <span className="text-xs col-span-2 text-ellipsis max-w-[200px] overflow-hidden">{candidateStatus}</span>
                      </Tooltip>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Updated on</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{updatedDate}</span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 col-span-3">
                    <div className="grid grid-cols-3 gap-2">
                      <Tooltip title="Work Authorization">
                        <span className="text-xs text-ellipsis overflow-hidden">Work Authorization</span>
                      </Tooltip>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{visaStatus}</span>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Location</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{locationsOptions.find((option) => option.value === location)?.label}</span>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Relocation</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{reLocation ? 'Yes' : 'No'}</span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 col-span-3">
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Experience</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{experienceLevel}</span>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Pay Rate</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">
                        {currencyIcon}
                        {' '}
                        {payRate}
                      </span>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <span className="text-xs text-ellipsis overflow-hidden">Notice Period</span>
                      <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{noticePeriod}</span>
                    </div>
                  </div>
                  <Popover
                    sx={{
                      pointerEvents: 'none',
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                  >
                    <div className="min-h-[30px] text-xs p-2">
                      {interviewComments}
                    </div>
                  </Popover>
                  <Popover
                    sx={{
                      pointerEvents: 'none',
                    }}
                    open={pannaInterviewOpen}
                    anchorEl={pannaInterviewAnchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    onClose={handlePannaInterviewPopoverClose}
                    disableRestoreFocus
                  >
                    <div className="min-h-[30px] text-xs p-2">
                      {pannaInterviewComments}
                    </div>
                  </Popover>
                  <div className="flex flex-col gap-2 col-span-3 border-l-primary">
                    {
                      (techSkill || communicationSkills || oldTechSkill || oldCommunicationSkills)
                        ? (
                          <div
                            onMouseEnter={handlePopoverOpen}
                            onMouseLeave={handlePopoverClose}
                          >
                            {(techSkill || oldTechSkill) ? (
                              <div
                                className="grid grid-cols-3 gap-2"
                              >
                                <span className="text-xs text-ellipsis overflow-hidden">Tech</span>
                                <span className="text-xs col-span-2 text-ellipsis overflow-hidden">
                                  <Rating size="small" precision={0.5} disabled defaultValue={techSkill || oldTechSkill} />
                                </span>
                              </div>
                            ) : null}
                            {(communicationSkills || oldCommunicationSkills) ? (
                              <div className="grid grid-cols-3 gap-2">
                                <span className="text-xs text-ellipsis overflow-hidden">Communication</span>
                                <span className="text-xs col-span-2 text-ellipsis overflow-hidden">
                                  <Rating size="small" precision={0.5} disabled defaultValue={communicationSkills || oldCommunicationSkills} />
                                </span>
                              </div>
                            ) : null}
                          </div>
                        ) : null
                    }
                    {score ? (
                      <div
                        className="grid grid-cols-3 gap-2"
                        onMouseEnter={handlePannaInterviewPopoverOpen}
                        onMouseLeave={handlePannaInterviewPopoverClose}
                      >
                        <span className="text-xs text-ellipsis overflow-hidden">Paññã Score</span>
                        <span className="text-xs col-span-2 text-ellipsis overflow-hidden">{score}</span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <hr className="h-px m-0 bg-gray-200 border-0 dark:bg-gray-700" />
          </>
        );
      },
    }),
  ], [openBookmarks, rowSelection]);

  return (
    <Table
      loading={profilesFetching}
      data={records}
      onRowSelection={onRowSelectionChange}
      rowSelection={rowSelection}
      columns={columns}
      pageSize={20}
      onRowClick={onRowClick}
      manualPagination={pagination}
      onChangePagination={onChangePagination}
      classes={{
        td: 'p-0',
      }}
    />
  );
};

TalentPoolTable.defaultProps = {

};

TalentPoolTable.propTypes = {

};

export default TalentPoolTable;
